import React from "react";
import { SmartImage } from "@/components/SmartImage";

export const CategoryChips = ({ categories, active, onSelect }) => {
  return (
    <div
      className="flex overflow-x-auto hide-scrollbar gap-3 py-1 px-4 sm:px-0 justify-start sm:justify-center"
      data-testid="category-chips-container"
    >
      {categories.map(cat => {
        const isActive = active === cat.id;
        const isSoon = cat.coming_soon;
        return (
          <button
            key={cat.id}
            data-testid={`category-chip-${cat.id}`}
            onClick={() => onSelect(cat.id)}
            className="flex flex-col items-center gap-1 min-w-[60px] group"
          >
            <div className={`w-12 h-12 rounded-full p-[2px] transition-all ${isActive ? "bg-gradient-to-br from-[#D81B60] via-[#F06292] to-[#FCE4EC]" : "bg-[#F4D8E2] group-hover:bg-[#F8BBD0]"}`}>
              <div className="w-full h-full rounded-full overflow-hidden bg-white p-0.5 relative">
                <SmartImage
                  src={cat.image}
                  alt={cat.name}
                  width={96}
                  widths={[48, 96, 144]}
                  sizes="48px"
                  className={`w-full h-full object-cover rounded-full transition ${isSoon ? "grayscale opacity-60" : ""}`}
                />
                {isSoon && (
                  <span className="absolute bottom-0 inset-x-0 bg-[#2D0A22]/70 text-white text-[7px] font-bold text-center py-0.5 tracking-wider">
                    SOON
                  </span>
                )}
              </div>
            </div>
            <span className={`text-[10px] font-medium text-center whitespace-nowrap ${isActive ? "text-[#D81B60]" : "text-[#2D0A22]"}`}>
              {cat.name}
            </span>
          </button>
        );
      })}
    </div>
  );
};
